import React from "react";
import IPOContent from "../../components/layouts/misi-internasional/IPOContent";

const IPO: React.FC = () => {
  return (
    <div>
      <IPOContent />
    </div>
  );
};

export default IPO;
